import { useState } from "react";
import { Button, Col, Form, Input, Modal, Row } from "antd";

const EditEelectronicSignature = ({ showModal, cancelModal }) => {
  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            maskClosable={false}
            title="Set Up Your Signature"
            open={showModal}
            onCancel={cancelModal}
            footer={[
              <Button key="back" onClick={cancelModal}>
                Cancel
              </Button>,
              <Button key="submit" type="primary">
                Update Signature
              </Button>,
            ]}
          >
            Please enter your full name and initials below to update your
            current online signature. The information you enter will be the
            electronic representation of your signature and initials on future
            agreements.
            <Form layout="vertical" style={{ marginTop: "20px" }}>
              <Form.Item
                label="Your full name"
                name="fullName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Full Name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Initials"
                name="initials"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Initials",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Form>
          </Modal>
        </Col>
      </Row>
    </div>
  );
};

export default EditEelectronicSignature;
